import { createAsyncThunk } from "@reduxjs/toolkit";
import { patient_without_pharmacist_sign } from "../../../networking/urlEndPoints";
import Axios from "../../../networking/interceptor";

export const fetchPatientListWithoutPharmacistSign = createAsyncThunk(
    'fetchPatientListWithoutPharmacistSign',
    async ({ pharmacy_id, pharmacist_id, page, setLoading, setLoadMore }, { rejectWithValue }) => {
        try {
            const response = await Axios.get(`${patient_without_pharmacist_sign}`, {
                params: { pharmacy_id, pharmacist_id, page }
            });

            setLoading?.(false);
            setLoadMore?.(false);

            return response.data;
        } catch (error) {
            setLoading?.(false);
            setLoadMore?.(false);
            return rejectWithValue(error.response);
        }
    }
);